var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-layout',{staticClass:"ma-0 pa-0 the-loading",attrs:{"justify-center":"","align-content-center":""}},[_c('v-flex',{attrs:{"xs6":"","align-self-center":""}},[_c('v-progress-linear',{attrs:{"indeterminate":"","height":"8","rounded":""}}),_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }